/**
 * Takes a LatLng string like "33.2,-122.25" and returns a separate
 * number for the Lat and Lng: [33.2, -122.25].
 */
export default (val: string | undefined) => {
  if (val) {
    const coords = val.split(',');
    if (coords.length === 2 && !Number.isNaN(coords[0]) && !Number.isNaN(coords[1])) {
      return [Number.parseFloat(coords[0]), Number.parseFloat(coords[1])] as [number, number];
    }
  }
  return [0, 0];
};
